import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { SiteActions } from 'app/report-details/state/actions';

import { AppActions } from '.';
import { RootState } from '../app.config';

@Injectable({
    providedIn: 'root',
})
export class AppFacade {
    constructor(private readonly store$: Store<RootState>) {}

    loadAllUsers(siteId: string): void {
        this.store$.dispatch(AppActions.loadUsers({ siteId }));
    }

    closeDialog(): void {
        this.store$.dispatch(AppActions.closeDialog());
    }

    getSites(): void {
        this.store$.dispatch(SiteActions.getSites());
    }
}
